/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N800, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { StyledOutlineLink } from '../../utils/styled/links';
import { ellipsisInFlexChild } from '../../utils/styled/text';

export const OutlineLink = StyledOutlineLink.withComponent('button');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileItemWrapper = styled.div`
	display: flex;
	flex-basis: auto;
	${ellipsisInFlexChild}
	height: ${token('space.500', '40px')};
	align-items: center;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileItemAvatar = styled.div`
	display: flex;
	padding-right: ${token('space.100', '8px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileAddIconOld = styled.div`
	display: flex;
	padding-right: ${token('space.100', '8px')};
	margin: 0px ${token('space.075', '6px')} ${token('space.025', '2px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileAddIcon = styled.div`
	display: flex;
	padding-right: ${token('space.100', '8px')};
	margin: ${token('space.025', '2px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileItemBody = styled.div`
	display: flex;
	flex-flow: column;
	flex-basis: auto;
	${ellipsisInFlexChild};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileItemTeamName = styled.div`
	font: ${token('font.body')};
	padding-bottom: ${token('space.025', '2px')};
	flex-basis: auto;
	${ellipsisInFlexChild}

	color: ${token('color.text', N800)};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamsProfileItemTeamMembers = styled.div`
	font: ${token('font.body.small')};
	color: ${token('color.text.subtlest', N90)};
`;
